/* eslint-disable no-empty */
import { Level, Metric } from './types'
import {
  EventArgs,
  LogArgs,
  EventLogMain,
  SetConfigArgs,
} from './event-log-main'
import { SetMetricsConfigArgs } from './metrics/metrics.types'

export { Batch, Event, EventLogType, Level, Log, Metric } from './types'
export class EventLog extends EventLogMain {
  event(eventArgs: EventArgs) {
    return this.setEvent({
      eventLogArgs: eventArgs,
      level: Level.INFO,
    })
  }

  logger = {
    error: (logArgs: LogArgs) => {
      return this.setLog({
        eventLogArgs: logArgs,
        level: Level.ERROR,
      })
    },
    debug: (logArgs: LogArgs) => {
      return this.setLog({
        eventLogArgs: logArgs,
        level: Level.DEBUG,
      })
    },
    info: (logArgs: LogArgs) => {
      return this.setLog({
        eventLogArgs: logArgs,
        level: Level.INFO,
      })
    }
  }

  setMetric(metricArgs: Metric): Promise<void> {
    if (!this.metrics) {
      return Promise.resolve()
    }

    return this.metrics.setMetric(metricArgs, this.maxBatchQueued)
  }

  async sendBatch() {
    if(this.debug) {
      console.log('Loggers sendBatch')
    }
    try {
      const items = await this.database.getAllItems()

      if (items.length) {
        await this.api.sendBatch(items)
      }
    } catch (_) { }

    return Promise.resolve()
  }

  async sendMetricBatch() {
    if (!this.metrics) {
      return Promise.resolve()
    }
    try {
      await this.metrics.sendBatch()
    } catch (_) { }
    return Promise.resolve()
  }

  getDeviceId() {
    return this.deviceId
  }

  setConfig({
    enableCron,
    batchTime,
    enableEvents,
    enableLogs,
    maxBatchQueued,
  }: SetConfigArgs) {
    this.enableEvents =
      enableEvents !== undefined ? enableEvents : this.enableEvents
    this.enableLogs = enableLogs !== undefined ? enableLogs : this.enableLogs
    this.enableCron = enableCron !== undefined ? enableCron : this.enableCron
    this.batchTime = batchTime !== undefined ? batchTime : this.batchTime
    this.maxBatchQueued =
      maxBatchQueued !== undefined ? maxBatchQueued : this.maxBatchQueued

    this.startCron()
  }

  setMetricsConfig(args: SetMetricsConfigArgs) {
    if(!this.metrics) {
      return
    }
    this.metrics.setConfig(args)
  }
}
